import { AsidePanelActionsButton } from '../../../..';
import * as React from 'react';
import { ICardEstimateAndSpentTimePanelButton } from './types';
import { CLASS_CARD_DETAILS_SECTION } from '../../../constants';
import { CLASS_ASIDE_PANEL_ACTIONS_POPUP } from '../../../../asidePanel/components/AsidePanelActionsButton/constants';
import { EAsidePanelProperty } from '../../../../asidePanel/components/AsidePanel/types';
import { AsidePanelContext } from '../../../../asidePanel/components/AsidePanel/constants';
import { getAsidePanelActionsButtonTooltip } from 'app/view/react_components/aside_panel/asidePanel/helpers/getAsidePanelActionsButtonTooltip';

export function CardEstimateAndSpentTimePanelButton({
    estimateFlag,
    isShow,
    tooltip,
    onClick
}: ICardEstimateAndSpentTimePanelButton) {
    if (!isShow) return null;

    const classNameSection = CLASS_CARD_DETAILS_SECTION + '--estimate';

    const { isCommentsColumn, showedProperties, openedProperty, addShowedProperty } = React.useContext(AsidePanelContext);
    const isShowed = showedProperties.has(EAsidePanelProperty.CARD_ESTIMATE) && openedProperty !== EAsidePanelProperty.CARD_ESTIMATE;
    const [isOpened, setIsOpened] = React.useState(null);
    const onOpened = () => setIsOpened(true);
    const onClosed = () => setIsOpened(false);
    return (
        <AsidePanelActionsButton
            dropdownClassName={`${CLASS_ASIDE_PANEL_ACTIONS_POPUP}--estimate`}
            indicatorBoolean={estimateFlag}
            icon={'estimate'}
            isOpened={isOpened}
            isIconHiddenOnFullSize={true}
            openedProperty={EAsidePanelProperty.CARD_ESTIMATE}
            sectionSelector={`.${classNameSection}`}
            sectionElementSelector={`.${classNameSection}`} // чтобы зафокусить инпут
            title={'Estimate'}
            tooltip={tooltip && getAsidePanelActionsButtonTooltip({ value: tooltip })}
            onClick={() => {
                onClick();
                if (!isShowed) {
                    addShowedProperty(EAsidePanelProperty.CARD_ESTIMATE, isCommentsColumn);
                    setTimeout(() => {
                        const button = document.querySelector(`.${classNameSection} .settings-section__title-add`) as HTMLButtonElement;
                        if (button) {
                            button.focus();
                            button.click();
                        }
                    }, 1000);
                }
            }}
            onOpen={onOpened}
        >
        </AsidePanelActionsButton>
    );
}
